import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=6fac8c72&scoped=true&"
import script from "./myFooter.vue?vue&type=script&lang=js&"
export * from "./myFooter.vue?vue&type=script&lang=js&"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=6fac8c72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac8c72",
  null
  
)

export default component.exports